/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SwgenRouteImport } from './routes/swgen'
import { Route as ReadingJournalRouteImport } from './routes/reading-journal'
import { Route as PublicationsRouteImport } from './routes/publications'
import { Route as MyKeebRouteImport } from './routes/my-keeb'
import { Route as Frc360LogoRouteImport } from './routes/frc-360-logo'
import { Route as CoffeePotRouteImport } from './routes/coffee-pot'
import { Route as IndexRouteImport } from './routes/index'

const SwgenRoute = SwgenRouteImport.update({
  id: '/swgen',
  path: '/swgen',
  getParentRoute: () => rootRouteImport,
} as any)
const ReadingJournalRoute = ReadingJournalRouteImport.update({
  id: '/reading-journal',
  path: '/reading-journal',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicationsRoute = PublicationsRouteImport.update({
  id: '/publications',
  path: '/publications',
  getParentRoute: () => rootRouteImport,
} as any)
const MyKeebRoute = MyKeebRouteImport.update({
  id: '/my-keeb',
  path: '/my-keeb',
  getParentRoute: () => rootRouteImport,
} as any)
const Frc360LogoRoute = Frc360LogoRouteImport.update({
  id: '/frc-360-logo',
  path: '/frc-360-logo',
  getParentRoute: () => rootRouteImport,
} as any)
const CoffeePotRoute = CoffeePotRouteImport.update({
  id: '/coffee-pot',
  path: '/coffee-pot',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/coffee-pot': typeof CoffeePotRoute
  '/frc-360-logo': typeof Frc360LogoRoute
  '/my-keeb': typeof MyKeebRoute
  '/publications': typeof PublicationsRoute
  '/reading-journal': typeof ReadingJournalRoute
  '/swgen': typeof SwgenRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/coffee-pot': typeof CoffeePotRoute
  '/frc-360-logo': typeof Frc360LogoRoute
  '/my-keeb': typeof MyKeebRoute
  '/publications': typeof PublicationsRoute
  '/reading-journal': typeof ReadingJournalRoute
  '/swgen': typeof SwgenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/coffee-pot': typeof CoffeePotRoute
  '/frc-360-logo': typeof Frc360LogoRoute
  '/my-keeb': typeof MyKeebRoute
  '/publications': typeof PublicationsRoute
  '/reading-journal': typeof ReadingJournalRoute
  '/swgen': typeof SwgenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/coffee-pot'
    | '/frc-360-logo'
    | '/my-keeb'
    | '/publications'
    | '/reading-journal'
    | '/swgen'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/coffee-pot'
    | '/frc-360-logo'
    | '/my-keeb'
    | '/publications'
    | '/reading-journal'
    | '/swgen'
  id:
    | '__root__'
    | '/'
    | '/coffee-pot'
    | '/frc-360-logo'
    | '/my-keeb'
    | '/publications'
    | '/reading-journal'
    | '/swgen'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CoffeePotRoute: typeof CoffeePotRoute
  Frc360LogoRoute: typeof Frc360LogoRoute
  MyKeebRoute: typeof MyKeebRoute
  PublicationsRoute: typeof PublicationsRoute
  ReadingJournalRoute: typeof ReadingJournalRoute
  SwgenRoute: typeof SwgenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/swgen': {
      id: '/swgen'
      path: '/swgen'
      fullPath: '/swgen'
      preLoaderRoute: typeof SwgenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reading-journal': {
      id: '/reading-journal'
      path: '/reading-journal'
      fullPath: '/reading-journal'
      preLoaderRoute: typeof ReadingJournalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/publications': {
      id: '/publications'
      path: '/publications'
      fullPath: '/publications'
      preLoaderRoute: typeof PublicationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-keeb': {
      id: '/my-keeb'
      path: '/my-keeb'
      fullPath: '/my-keeb'
      preLoaderRoute: typeof MyKeebRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/frc-360-logo': {
      id: '/frc-360-logo'
      path: '/frc-360-logo'
      fullPath: '/frc-360-logo'
      preLoaderRoute: typeof Frc360LogoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coffee-pot': {
      id: '/coffee-pot'
      path: '/coffee-pot'
      fullPath: '/coffee-pot'
      preLoaderRoute: typeof CoffeePotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CoffeePotRoute: CoffeePotRoute,
  Frc360LogoRoute: Frc360LogoRoute,
  MyKeebRoute: MyKeebRoute,
  PublicationsRoute: PublicationsRoute,
  ReadingJournalRoute: ReadingJournalRoute,
  SwgenRoute: SwgenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
